// extracted by mini-css-extract-plugin
export default {"cls1":"Loading-LoadingGrid_cls1__CMiaA","cls2":"Loading-LoadingGrid_cls2__YCgsN Loading-LoadingGrid_cls1__CMiaA"};